import { FilterSection } from './filter-section';
import { HeroBanner } from './hero-section/hero-heading';

export const AllIntegrations = (): JSX.Element => {
  return (
    <>
      <div className="bg-[#F9FAFD]" data-testid="integration">
        <div className="wg-container py-8">
          <HeroBanner />
        </div>
      </div>
      <FilterSection />
    </>
  );
};
